import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "./styles/viewport-responsive.css"
import App from "./App.vue"
import router from "./router"
import "./utils/viewport-adapter.js"
import i18n from "./i18n"
Vue.use(ElementUI)
Vue.config.productionTip = false

// 强制设置默认语言为中文
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', 'zh')
  i18n.locale = 'zh'
}

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
